<template>
  <header
    v-show="!isVrMode && !isFullscreen"
    class="i-header"
  >
    <div
      class="header-intro"
      :class="{ 'screen-ready': isScreenReady }"
    />
    <div
      class="header-center"
      :class="{ 'screen-ready': isScreenReady }"
    >
      <div
        v-if="!isHideLiveTourName"
        class="header-title"
        :class="{
          'active': isModalBuildingInfoVisble,
          'pointer-cursor': hasDescription || hasAdvertiseLink
        }"
      >
        <div
          class="header-title-inner"
          @click="onTitleClick"
        >
          <span>{{ currentBuilding.nameMulti[lang] || currentBuilding.name }}</span>
          <i
            v-if="hasDescription"
            class="isif"
            :class="isModalBuildingInfoVisble ? 'isif-arrow-up' : 'isif-arrow-down'"
          />
          <i
            v-else-if="hasAdvertiseLink"
            class="isif isif-foreign"
          />
        </div>
      </div>
    </div>
    <portrait
      class="portrait"
      dropdown-position="right"
    />
    <ModalBuildingInfo
      ref="ModalBuildingInfo"
      @opened="onModalBuildingInfoOpened"
      @closed="onModalBuildingInfoClosed"
    />
  </header>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import ModalBuildingInfo from '../../components/common/modals/ModalBuildingInfo'
import Portrait from '@/components/Portrait'
import queryString from '../../api/query-string'
export default {
  name: 'IHeader',
  components: {
    ModalBuildingInfo,
    Portrait
  },
  data () {
    return {
      defaultColor: '#fff',
      icon: {
        website: {
          name: 'website',
          color: this.defaultColor
        }
      },
      isModalBuildingInfoVisble: false,
      tempPanoramasListActive: undefined,
      lang: this.$i18n.locale
    }
  },

  computed: {
    ...mapGetters([
      'currentBuilding',
      'mainColor',
      'isFullscreen',
      'isScreenReady',
      'isVrMode',
      'isPanoramasListActive'
    ]),

    isHideLiveTourName () {
      return queryString.hideLTName
    },

    hasDescription () {
      return !_.isEmpty(this.currentBuilding.description)
    },

    hasAdvertiseLink () {
      return !_.isEmpty(this.currentBuilding.advertiseLink)
    }
  },

  methods: {
    ...mapActions([
      'showPanoramasList',
      'closePanoramasList'
    ]),
    changeColor (key = {}, value = '') {
      if (!key && !key.color) {
        return
      }
      key.color = value
    },
    onTitleClick () {
      if (this.hasDescription) {
        // Has description => Open modal.
        this.$refs.ModalBuildingInfo.show()
        this.$store.dispatch('setBuildingInfoActive', true)
      } else if (this.hasAdvertiseLink) {
        // No description & Has link => Open link.
        const advertiseLink = this.currentBuilding.advertiseLink
        const win = /^https?:\/\//.test(advertiseLink)
          ? window.open(`${advertiseLink}`, '_blank')
          : window.open(`https://${advertiseLink}`, '_blank')
        win.focus()
      }
      // No description & No link => Nothing happen.
    },

    onModalBuildingInfoOpened () {
      this.tempPanoramasListActive = this.isPanoramasListActive
      this.closePanoramasList()
      this.isModalBuildingInfoVisble = true
    },
    onModalBuildingInfoClosed () {
      if (this.tempPanoramasListActive) this.showPanoramasList()
      this.isModalBuildingInfoVisble = false
      this.$store.dispatch('setBuildingInfoActive', false)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

@media (max-width: $response) {
  .i-header .portrait{
    left: 20px !important;
  }
}

.i-header {
  position: absolute
  width: 100%
  z-index: $i-header-z
  pointer-events: none

  @media (min-width: $response) {
    z-index: $i-header-z
  }

  .portrait {
    display: block
    position: absolute
    top: 24px
    left: 32px
    pointer-events: all
  }
}

.header-intro {
  position: absolute
  left: $i-header-header-intro-pos
  top: 15px
  opacity: 0
  transform: translateX(-($i-header-header-intro-pos))
  transition: .3s opacity ease-out, .3s transform ease-out

  &.screen-ready {
    opacity: 1
    transform: none
  }

  @media (min-width: $response) {
    left: $i-header-header-intro-large-pos
    top: 28px
  }
}

.header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 1.4rem;
  right: 3.75rem;
  left: 3.75rem;
  transition: .3s opacity ease-out, .3s transform ease-out;
  transform: translateY(-20px);
  text-align: center;
  color: $white;

  @media (min-width: $response) {
    top: 1.75rem
    left: 0
    right: 0
  }

  &.screen-ready {
    opacity: 1
    transform: none
  }

  .header-social {
    display: flex;
    width: 20%;
    width: fit-content;
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .header-intro {
    left: auto
    right: $i-header-header-intro-pos
    transform: translateX($i-header-header-intro-pos)

    &.screen-ready {
      opacity: 1
      transform: none
    }

    @media (min-width: $response) {
      left: auto
      right: $i-header-header-intro-large-pos
    }
  }

  .header-center {
    right: auto
    left: $i-header-header-center-pos

    @media (min-width: $response) {
      left: auto
      right: auto
    }
  }
}

.header-title {
  margin: auto;
  width: 100%;
  cursor: default;
  pointer-events: auto;

  &.pointer-cursor {
    cursor: pointer;
  }

  @media (min-width: $response) {
    width: 39.58%
  }

  .header-title-inner {
    max-width: 100%
    padding: .5em 2em
    display: inline-flex
    align-items: center
    justify-content: center
    position: relative

    i {
      margin-left: .5em
    }

    span {
      width: 100%
      display: inline-block
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &::after {
      content: ''
      position: absolute
      top: 0
      bottom: 0
      left: 0
      right: 0
      z-index: -1
      background: -moz-linear-gradient(left,  rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 100%)
      background: -webkit-linear-gradient(left,  rgba(0,0,0,0) 0%,rgba(0,0,0,0.6) 50%,rgba(0,0,0,0) 100%)
      background: linear-gradient(to right,  rgba(0,0,0,0) 0%,rgba(0,0,0,0.6) 50%,rgba(0,0,0,0) 100%)
      filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr=#00000000, endColorstr=#00000000 ,GradientType=1 )'
    }
  }

  &:hover,
  &.active {
    .header-title-inner {
      &::after {
      background: -moz-linear-gradient(left,  rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0) 100%)
      background: -webkit-linear-gradient(left,  rgba(0,0,0,0) 0%,rgba(0,0,0,0.8) 50%,rgba(0,0,0,0) 100%)
      background: linear-gradient(to right,  rgba(0,0,0,0) 0%,rgba(0,0,0,0.8) 50%,rgba(0,0,0,0) 100%)
      filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr=#00000000, endColorstr=#00000000 ,GradientType=1 )'
      }
    }
  }
}
</style>
